export const SERIES_COLORS = [
  {
    bg: 'bg-orange-700',
    border: 'border-orange-800',
    text: 'text-orange-700',
    fill: 'hsl(var(--fpds-color-orange-7))',
  },
  {
    bg: 'bg-purple-700',
    border: 'border-purple-800',
    text: 'text-purple-700',
    fill: 'hsl(var(--fpds-color-purple-7))',
  },
  { bg: 'bg-blue-700', border: 'border-blue-800', text: 'text-blue-700', fill: 'hsl(var(--fpds-color-blue-7))' },
  { bg: 'bg-green-700', border: 'border-green-800', text: 'text-green-700', fill: 'hsl(var(--fpds-color-green-7))' },
  {
    bg: 'bg-yellow-700',
    border: 'border-yellow-800',
    text: 'text-yellow-700',
    fill: 'hsl(var(--fpds-color-yellow-7))',
  },
  { bg: 'bg-gray-700', border: 'border-gray-800', text: 'text-gray-700', fill: 'hsl(var(--fpds-color-gray-7))' },
] as const
